module.exports = __webpack_public_path__ + "static/media/launch.fc709d5e.svg";